import type { FC, PropsWithChildren, ReactNode } from "react";

/* -------------------------------------------------------------------------------------------------
 * CanAccess
 * -----------------------------------------------------------------------------------------------*/

export interface CanAccessProps extends PropsWithChildren {
  isAuthorized: boolean | undefined;
  fallback?: ReactNode;
}

const CanAccess: FC<CanAccessProps> = ({ isAuthorized = false, fallback, children }) => {
  if (isAuthorized) return children;
  return fallback ?? null;
};

CanAccess.displayName = "CanAccess";

export { CanAccess };
